import React from 'react';

export const Story = ({ className }: { className: string }) => (
  <svg
    className={className}
    width="310"
    height="207"
    viewBox="0 0 310 207"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.25" filter="url(#filter0_d)">
      <rect x="4" y="0.0915527" width="301.462" height="105.61" fill="#75787A" />
      <rect x="4" y="105.702" width="301.462" height="92.409" fill="#EFF2F5" />
      <rect x="14.2188" y="118.904" width="79.1977" height="15.8416" fill="#979797" />
      <rect x="116.41" y="118.904" width="81.7525" height="15.8416" fill="#979797" />
      <rect x="218.6" y="118.904" width="79.1977" height="15.8416" fill="#979797" />
      <rect x="14.2188" y="142.666" width="79.1977" height="7.92078" fill="#C4C4C4" />
      <rect x="14.2188" y="155.868" width="79.1977" height="7.92078" fill="#C4C4C4" />
      <rect x="14.2188" y="169.067" width="79.1977" height="7.92078" fill="#C4C4C4" />
      <rect x="116.41" y="142.666" width="81.7525" height="7.92078" fill="#C4C4C4" />
      <rect x="116.41" y="155.868" width="81.7525" height="7.92078" fill="#C4C4C4" />
      <rect x="116.41" y="169.067" width="81.7525" height="7.92078" fill="#C4C4C4" />
      <rect x="218.6" y="142.666" width="79.1977" height="7.92078" fill="#C4C4C4" />
      <rect x="218.6" y="155.868" width="79.1977" height="7.92078" fill="#C4C4C4" />
      <rect x="218.6" y="169.067" width="79.1977" height="7.92078" fill="#C4C4C4" />
      <rect x="13.5806" y="49.5964" width="153.286" height="23.7623" fill="#EFF2F5" />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0.0915527"
        width="309.462"
        height="206.02"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);
